/* eslint-disable react/require-default-props */

import React from 'react';

const Container = (props) => (
  <article className={`chart-container ${props.additionalClass ? props.additionalClass : ''}`}>
    <h1 className="chart-title">
      {props.chartName} <small>{props.chartDescription}</small>
    </h1>

    {props.children}
  </article>
);

export default Container;
